export enum PeriodStatus {
  CURRENT = 'current',
  FUTURE = 'future',
  PAST = 'past',
  UNKNOWN = 'unknown',
}
